import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { SHADOW_PROJECT_TYPE } from '../../../constants';
import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { NavigationWrapper, TabItems } from '../../ui';

type Props = React.PropsWithChildren<RouteComponentProps>;

const UserStorageTabs = ({ match, children }: Props): JSX.Element => {
  const {
    dashboardPath,
    navigationPath,
    userAttributesPath,
    userDataStoragePath,
    usersPath,
    userSupplementaryInfoPath
  } = usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  const { currentProject } = useCurrentProject(projectId);

  const tabItems: TabItems = [
    {
      label: intl.formatMessage({ id: 'user-data-base.settings.tabs.users' }),
      href: usersPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'user-data-base.settings.tabs.data-storage' }),
      href: userDataStoragePath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'user-data-base.settings.tabs.user-supplementary-info' }),
      href: userSupplementaryInfoPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'user-data-base.settings.tabs.user-attributes' }),
      href: userAttributesPath(projectId)
    }
  ];

  const shadowTabItems: TabItems = [
    {
      label: intl.formatMessage({ id: 'user-data-base.settings.tabs.users' }),
      href: usersPath(projectId)
    }
  ];

  const breadCrumbsOptions = [
    {
      label: intl.messages['dashboard.label'],
      to: dashboardPath()
    },
    {
      label: currentProject?.name,
      to: navigationPath(projectId)
    },
    {
      label: intl.messages['user-data-base.breadcrumb.label'],
      to: `#`
    }
  ];

  return (
    <NavigationWrapper
      breadCrumbsOptions={breadCrumbsOptions}
      tabsItems={currentProject?.type !== SHADOW_PROJECT_TYPE ? tabItems : shadowTabItems}
      dataTestId="user-storage">
      {children}
    </NavigationWrapper>
  );
};

export default withRouter(UserStorageTabs);
